var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationBellBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10775 5.12484C4.34558 2.73436 6.39489 1.0415 8.84421 1.0415H10.3225C12.7718 1.0415 14.8211 2.73436 15.0589 5.12484L15.5532 10.3748C15.7325 12.1762 16.507 14.0032 17.7589 15.3332C18.3847 15.9981 17.9038 17.3748 16.9811 17.3748H2.18557C1.26284 17.3748 0.781922 15.9981 1.4078 15.3332C2.65971 14.0032 3.43421 12.1762 3.61343 10.3748L4.10775 5.12484Z",
    stroke: "#5BA7EE",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95834 17.3748H12.2083V17.6665C12.2083 19.1163 11.0331 20.2915 9.58334 20.2915C8.13359 20.2915 6.95834 19.1163 6.95834 17.6665V17.3748Z",
    stroke: "#5BA7EE",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellBlue);
export default __webpack_public_path__ + "static/media/NotificationBell_blue.95072d3d97b6a88b07d069b640c562b4.svg";
export { ForwardRef as ReactComponent };